import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=83752c9e&scoped=true&"
import script from "./ReviewPage.vue?vue&type=script&lang=js&"
export * from "./ReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=83752c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83752c9e",
  null
  
)

export default component.exports